import createReactComponent from '../createReactComponent';
export default createReactComponent('access-point', 'IconAccessPoint', [
  ['path', { d: 'M12 12l0 .01', key: 'svg-0' }],
  ['path', { d: 'M14.828 9.172a4 4 0 0 1 0 5.656', key: 'svg-1' }],
  ['path', { d: 'M17.657 6.343a8 8 0 0 1 0 11.314', key: 'svg-2' }],
  ['path', { d: 'M9.168 14.828a4 4 0 0 1 0 -5.656', key: 'svg-3' }],
  ['path', { d: 'M6.337 17.657a8 8 0 0 1 0 -11.314', key: 'svg-4' }],
]);
